import { render } from "./defaultDirectionComponent.vue?vue&type=template&id=0eb8524c"
import script from "./defaultDirectionComponent.vue?vue&type=script&lang=js"
export * from "./defaultDirectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__